import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
  selector     : 'nz-layout',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <ng-content></ng-content>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-layout {
  display: flex;
  flex-direction: column;
  flex: auto;
  background: #ececec;
}
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
}
.ant-layout.ant-layout-has-sider > .ant-layout,
.ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: hidden;
}
.ant-layout-header,
.ant-layout-footer {
  flex: 0 0 auto;
}
.ant-layout-header {
  background: #404040;
  padding: 0 50px;
  height: 64px;
  line-height: 64px;
}
.ant-layout-footer {
  background: #ececec;
  padding: 24px 50px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}
.ant-layout-content {
  flex: auto;
}
.ant-layout-sider {
  transition: all .2s;
  position: relative;
  background: #404040;
  /* fix firefox can't set width smaller than content on flex item */
  min-width: 0;
}
.ant-layout-sider-children {
  height: 100%;
  padding-top: 0.1px;
  margin-top: -0.1px;
}
.ant-layout-sider-has-trigger {
  padding-bottom: 48px;
}
.ant-layout-sider-right {
  order: 1;
}
.ant-layout-sider-trigger {
  position: fixed;
  text-align: center;
  bottom: 0;
  cursor: pointer;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #404040;
  z-index: 1;
  transition: all 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-layout-sider-zero-width > * {
  overflow: hidden;
}
.ant-layout-sider-zero-width-trigger {
  position: absolute;
  top: 64px;
  right: -36px;
  text-align: center;
  width: 36px;
  height: 42px;
  line-height: 42px;
  background: #404040;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  transition: background .3s ease;
}
.ant-layout-sider-zero-width-trigger:hover {
  background: #535353;
}
`,
    `nz-layout,
nz-footer,
nz-header,
nz-content {
  display: block;
}
.ant-layout-sider-trigger {
  width: 100%;
  position: absolute;
}
`
  ],
  host: {
    '[class.ant-layout]': 'true'
  }
})
export class NzLayoutComponent {
  @HostBinding('class.ant-layout-has-sider') hasSider = false;
}
